import { Component, computed, effect, inject, input, model, output, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { Alert, careerResourceItem, jobsItem, Message, mybdjobsItem,Reminder } from '../utils/nav.const';
import { TranslocoModule} from '@jsverse/transloco';
import { BdjobsProfileUrl, DashboardUrl, EMPLOYER_MSG_URL, PricingPageUrl, VideoCVUrl } from '../../../shared/enums/app.enums';
import { ScrollService } from '../../services/scroll/scroll.service';
import { JOBS_URL} from '../../../shared/consts/shared.const';
import { DeviceDetectionService } from '../../services/device-detection';
import { TimePipe } from "../../pipes/time-pipe";
import { LangOptions } from '../../../shared/models/models';
import { TruncatePipe } from "../../../shared/pipes/truncate.pipe";
import { FilterItem } from '../../../features/jobs/models/job-card.model';
import { isPlatformBrowser } from '@angular/common';
import { ProfileStatCard } from "../../../features/home/components/profile-stat-card/profile-stat-card";
import { DEFAULT_PROFILE_DATA } from '../../../features/home/models/common.models';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-responsive-nav',
  imports: [TranslocoModule, TimePipe, TruncatePipe, ProfileStatCard],
  templateUrl: './responsive-nav.html',
})
export class ResponsiveNav {
  private scrollService = inject(ScrollService)
  private deviceDetectionService = inject(DeviceDetectionService)
  private renderer2 = inject(Renderer2)
  private platformId = inject(PLATFORM_ID)
  environment = environment;
  isMenuOpen = model(false)
  isMessageRes = model(false)
  isNotificationRes = model(false)
  isEligibleForPersonalHiring = input(false)
  unreadNotification = input(0)
  isAuthenticated = input(false)
  isProUser = input<boolean | null>(null)
  mybdjobsItemUrl = input('')
  activeLang = input<LangOptions>('en')
  profileCompletionInfo = input(DEFAULT_PROFILE_DATA)
  editProfilePercentage = input(0)
  videoCvPercentage = input(0)
  messageList = input<Message[]>([] as Message[])
  alerts = input<Alert[]>([])
  reminders = input<Reminder[]>([])
  notificationClick = output<{ data: Alert | Reminder; isAlert: boolean }>();
  toggleButton = output<Event>();
  filterUrlClick = output<FilterItem>();
  markAllAsReadClick = output<void>();

  activeNotificationTab = signal<'alerts' | 'reminders'>('alerts')
  mybdjobsItem = mybdjobsItem
  jobsItem = jobsItem
  careerResourceItem = careerResourceItem
  jobs_url = JOBS_URL
  mybdjobsMsgUrl = EMPLOYER_MSG_URL;
  pricingPageUrl = PricingPageUrl;
  editProfileUrl = BdjobsProfileUrl;
  dashboardUrl = DashboardUrl;
  videoCvUrl = VideoCVUrl;

  isMobileDevice = this.deviceDetectionService.isMobile
  openSection = signal<string | null>('');

  constructor() {
    if(!isPlatformBrowser(this.platformId)) return;
    effect(() => {
      this.renderer2.setStyle(
        document.body, 'overflow', this.shouldLockBody() ? 'hidden' : ''
      );
    });
  }

  isSectionOpen(section: string):boolean {
    return this.openSection() === section;
  }

  toggleSection(section: string):void {
    this.openSection.set(this.openSection() === section ? null : section);
  }

  readonly shouldLockBody = computed(
    () => this.isMenuOpen() || this.isNotificationRes() || this.isMessageRes(),
  );

  onTenderClick(): void {
    this.isMenuOpen.set(false);
    this.scrollService.updateTenderClick(true);
  }

  toggleLang(event: Event):void {
    this.toggleButton.emit(event)
  }

  redirectNotification(data: Alert | Reminder, isAlert: boolean): void {
    this.notificationClick.emit({ data, isAlert });
  }

  onFilterUrlClick(item: FilterItem):void {
    this.isMenuOpen.set(false);
    this.filterUrlClick.emit(item);
  }

  onMarkAllAsReadClick(): void {
    this.markAllAsReadClick.emit();
  }
  
}
